import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/banner5-1920x450.png";

import BottomLogoImg from "../assets/Images/bottom-logo.png";
import decoration_page_img from "../assets/Images/HKAS_Website_Renovation_layout_V1-04.png";
import decoration_page_img_chi from "../assets/Images/HKAS_Website_Renovation_layout_V1-03.png";
import "./DecorationPage.scss";
import i18n from "i18next";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const DecorationPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">{t("hk_renovation_guideline")}</h1>
          <p className="banner-subtitle">{t("decoration_page_header2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_decoration_page_link1")}</Link>
        <span>{t("breadcrumbs_decoration_page_span")}</span>
        <Link>{t("breadcrumbs_decoration_page_link2")}</Link>
      </Breadcrumbs>
      <main className="decoration-main-container">
        <header className="decoration-header">
          <h2 className="decoration-title">{t("decoration_page_h3")}</h2>
        </header>
        <section className="decoration-content">
          <p className="decoration-text">{t("decoration_page_text1")}</p>
          <p className="decoration-text">{t("decoration_page_text2")}</p>
          <p className="decoration-text">{t("decoration_page_text3")}</p>
        </section>
        <section className="decoration-diagram">
          {i18n.language === "en" ? (
            <img
              src={decoration_page_img}
              alt="Decoration Process Diagram"
              className="diagram-image"
            />
          ) : (
            <img
              src={decoration_page_img_chi}
              alt="Decoration Process Diagram"
              className="diagram-image"
            />
          )}
        </section>
        <section>
          <button style={{ fontSize: "14px",
                            color: "#fff",
                            padding: "13px 28px",
                            backgroundColor: "#b12336",
                            marginTop: "20px" }}
            className="decoration-text"
            onClick={() =>
              {i18n.language === "en" ? navigator.clipboard.writeText(
                "Pursuant to the Charter of Harmony HK, any dispute or difference arising out of or in connection with this contract shall be brought to the Hong Kong Arbitration Society for mediation in accordance with the Hong Kong Arbitration Society Mediation Rules for the time being in force. Any such dispute not settled by mediation within the period in accordance with the Hong Kong Arbitration Society Mediation Rules for the time being in force, shall be referred to and finally determined by arbitration administrated by the Hong Kong Arbitration Society and in accordance with the Hong Kong Arbitration Society Rules for the time being in force."
              ) : 
              navigator.clipboard.writeText(
                "根據《和諧香港》約章，凡因本合同所引起的或與之相關的任何爭議或意見分歧，均應提交香港仲裁公會按照其現行有效的香港仲裁公會調解規則進行調解。如爭議未能在根據該調解規則時限內經過調解解決，均應提交香港仲裁公會並按照其現行有效的香港仲裁公會規則最終解決。"
              )}
            }
          >
            {t("decoration_page_text4")}
          </button>
        </section>
      </main>
      <section className="temporary">
        <img src={BottomLogoImg} alt="" />
      </section>
      <Footer />
    </>
  );
};

export default DecorationPage;
